import { registerAllAdapters } from "../adapters";

registerAllAdapters();
